import React from 'react';
import { motion } from 'framer-motion';
import { 
  Globe, 
  Crosshair, 
  Flame, 
  Building, 
  Star, 
  Scale, 
  CheckCircle, 
  MessageCircle 
} from 'lucide-react';
import './OutlineSlide.css';

const outlineItems = [
  { 
    number: '01', 
    title: 'Einleitung', 
    subtitle: 'Die Definition & Metapolitik',
    icon: Globe,
    color: '#ff3a3a'
  },
  { 
    number: '02', 
    title: 'Radikalisierung', 
    subtitle: 'USA: Der "Groyper War"',
    icon: Crosshair,
    color: '#ff6b35'
  },
  { 
    number: '03', 
    title: 'Provokation', 
    subtitle: 'Schweden: System-Hack',
    icon: Flame,
    color: '#ffc107'
  },
  { 
    number: '04', 
    title: 'An der Macht (1)', 
    subtitle: 'Polen & Ungarn',
    icon: Building,
    color: '#3a7fff'
  },
  { 
    number: '05', 
    title: 'An der Macht (2)', 
    subtitle: 'Israel',
    icon: Star,
    color: '#8b5cf6'
  },
  { 
    number: '06', 
    title: 'Doppelmoral', 
    subtitle: 'Echte Kritik vs. Propaganda',
    icon: Scale,
    color: '#10b981'
  },
  { 
    number: '07', 
    title: 'Fazit & Diskussion', 
    subtitle: 'Zusammenfassung und Fragen',
    icon: MessageCircle,
    color: '#ec4899'
  },
];

function OutlineSlide({ showNotes }) {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <div className="slide outline-slide">
      <div className="outline-header">
        <motion.span
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="section-label"
        >
          Übersicht
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="slide-title"
        >
          Gliederung
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="outline-intro"
        >
          Sieben Punkte über die globale Vernetzung der Neuen Rechten
        </motion.p>
      </div>

      <motion.div
        className="outline-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {outlineItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <motion.div
              key={index}
              className="outline-item"
              variants={itemVariants}
              whileHover={{ 
                scale: 1.02, 
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                transition: { duration: 0.2 }
              }}
              style={{ '--item-color': item.color }}
            >
              <div className="item-number">{item.number}</div>
              <div className="item-icon">
                <Icon size={24} strokeWidth={1.5} />
              </div>
              <div className="item-content">
                <h3 className="item-title">{item.title}</h3>
                <p className="item-subtitle">{item.subtitle}</p>
              </div>
              <div className="item-arrow">→</div>
            </motion.div>
          );
        })}
      </motion.div>

      {showNotes && (
        <div className="speaker-notes">
          <strong>📚 Zusatzinfos für Leser:</strong><br/>
          <strong>Der Fahrplan:</strong> Wir machen keine Geschichtsstunde, sondern analysieren die Mechanik des modernen Rechtsextremismus.<br/><br/>
          <strong>1. Radikalisierung (USA):</strong> Wie Jugendliche im Internet radikalisiert werden.<br/>
          <strong>2. Provokation (Schweden):</strong> Wie demokratische Gesetze als Waffe gegen die Demokratie genutzt werden (System Hack).<br/>
          <strong>3. An der Macht (Polen, Ungarn, Israel):</strong> Was passiert, wenn diese Ideologie regiert.<br/>
          <strong>4. Doppelmoral:</strong> Warum westliche Doppelmoral der beste Dünger für rechte Propaganda ist.
        </div>
      )}
    </div>
  );
}

export default OutlineSlide;
